import React from 'react';

const ValidateMessage = ({ required }) => {
  return (
    <div
      className="ant-form-item-explain ant-form-item-explain-error"
      style={
        required
          ? { display: 'inline-block', marginRight: '4px' }
          : { display: 'none' }
      }
    >
      <div role="alert">*</div>
    </div>
  );
};

export default ValidateMessage;
